import React from 'react';
import { useSelector } from 'react-redux';

import { Skeleton, Typography } from '@mui/material';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import {
  selectChartLegend,
  selectCommonInfoLoanApplication,
} from 'store/loanApplications/selectors';

import { getChartConfig } from './Chart.config';
import { CHART_HEIGHT, CHART_TITLE } from './Chart.constants';
import { chartStyles } from './Chart.styles';
import ChartSegment from './ChartSegment';

const Chart = ({ isLoading }) => {
  const chartLegend = useSelector(selectChartLegend);
  const { loanType } = useSelector(selectCommonInfoLoanApplication);

  const chartConfig = getChartConfig(chartLegend, loanType);

  return (
    <div className="w-full relative overflow-hidden">
      <Typography variant="medium16">{CHART_TITLE}</Typography>
      <div style={chartStyles}>
        {isLoading ? (
          <Skeleton height={CHART_HEIGHT} variant="rectangular" />
        ) : (
          <div className="flex w-full h-full">
            {chartConfig.map((segmentConfig, index) =>
              segmentConfig.isHidden ? null : <ChartSegment {...segmentConfig} key={index} />,
            )}
          </div>
        )}
      </div>
    </div>
  );
};

Chart.propTypes = {
  ...WithLoadingPropTypes,
};

export default Chart;
